import { render, staticRenderFns } from "./MaterialApplicationStep.vue?vue&type=template&id=6f866976&scoped=true"
import script from "./MaterialApplicationStep.vue?vue&type=script&lang=js"
export * from "./MaterialApplicationStep.vue?vue&type=script&lang=js"
import style0 from "./MaterialApplicationStep.vue?vue&type=style&index=0&id=6f866976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f866976",
  null
  
)

export default component.exports